import styled from "styled-components";
import { StyledOperatorTable } from "../../operator-views/operator-subcontactors";
import { theme } from "../../../helpers/theme";
import { GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import SessionService from "../../../services/session-service";
import { urlOperator, urlSubcontractor } from "../../../utils/url";
import { useNavigate } from "react-router-dom";
import { GetAllWarehouses } from "../../../services/warehouses/get-all/types";
import { useEffect } from "react";
import { GetByLoggedSubcontractorWarehouses } from "../../../services/warehouses/get-by-logged-subcontractor/types";

interface SubcontractorTableProps {
  subcontractorWarehouse: GetByLoggedSubcontractorWarehouses[];
}

const SubcontractorTable = ({
  subcontractorWarehouse,
}: SubcontractorTableProps) => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 430,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
              marginLeft: 0,
            }}
            onClick={() => {
              SessionService.setSubcontractors(params.row.wykonawcy);
              navigate(urlSubcontractor.subcontractorsDetails);
            }}
          >
            Dane Podwykonawcy
          </Button>

          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(
                `/subcontractor/subcontractors/storage-area/${params.id}`
              );
            }}
          >
            Obszary Składowania
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
              width: "194px",
            }}
            onClick={() => {
              return navigate(
                `/subcontractor/subcontractors/services/${params.id}`
              );
            }}
          >
            Usługi
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "green",
              width: "203px",
            }}
            onClick={() => {
              return navigate(
                `/subcontractor/subcontractors/price-list/${params.id}`
              );
            }}
          >
            Cennik
          </Button>
        </>
      ),
    },
    { field: "podwykonawca", headerName: "Podwykonawca", width: 200 },
    {
      field: "lokalizacja_magazynu",
      headerName: "Lokalizacja Magazynu",
      width: 300,
    },
    { field: "powierzchnia", headerName: "% Powierzchni", width: 150 },
    { field: "klasa", headerName: "Klasa", width: 100 },
    { field: "medyczny", headerName: "Medyczny", width: 100 },
    {
      field: "opis",
      headerName: "Opis",
      width: 300,
    },
  ];
  const getMagazineClassFromEnum = (type: number) => {
    switch (type) {
      case 0:
        return "A++";
      case 1:
        return "A+";
      case 2:
        return "A";
      case 3:
        return "B";
    }
  };

  const rows = subcontractorWarehouse.map(
    (r: GetByLoggedSubcontractorWarehouses) => ({
      id: r.id_magazyn,
      podwykonawca: r.kod_magazynu,
      lokalizacja_magazynu: r.adres
        ? `${r.adres?.kod_pocztowy && r.adres?.kod_pocztowy} ${
            r.adres?.miejscowosc
          }, ${r.adres?.ulica} ${
            r.adres?.numer_budynku ? r.adres.numer_budynku : ""
          }${r.adres?.numer_lokalu ? "/" + r.adres.numer_lokalu : ""}`
        : "Brak Danych",
      powierzchnia: r.powierzchnia_procentowa,
      klasa: getMagazineClassFromEnum(r.klasa_magazynu),
      medyczny: r.medyczny ? "Tak" : "Nie",
      opis: r.opis,
      wykonawcy: r.wykonawcy,
      magazyn_edited: {
        warehouses_data: {
          id_magazyn: r.id_magazyn,
          kod_magazynu: r.kod_magazynu,
          opis: r.opis,
          powierzchnia_procentowa: r.powierzchnia_procentowa,
          klasa_magazynu: r.klasa_magazynu,
          medyczny: r.medyczny,
          adres_id: r.adres.id_adres,
        },
        warehouses_adress: {
          id_magazyn: r.id_magazyn,
          kod_pocztowy: r.adres.kod_pocztowy,
          miejscowosc_poczty: r.adres.miejscowosc_poczty,
          miejscowosc: r.adres.miejscowosc,
          ulica: r.adres.ulica,
          numer_budynku: r.adres.numer_budynku,
          numer_lokalu: r.adres.numer_lokalu,
          wojewodztwo: r.adres.wojewodztwo,
          kraj: r.adres.kraj,
        },
      },
    })
  );
  return (
    <SubcontractorsContainer>
      <StyledOperatorTable
        getRowId={(row) => row?.id}
        rows={rows}
        columns={columns}
        hideFooter={true}
        pageSize={1}
        rowHeight={106}
        autoHeight
      />
    </SubcontractorsContainer>
  );
};

export default SubcontractorTable;

const SubcontractorsContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
